module.exports = __webpack_public_path__ + "assets/logo-pkxd-component.d060c63e.svg";